// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import { Multiselect } from "@wizardhealth/stimulus-multiselect"
import RailsNestedForm from "@stimulus-components/rails-nested-form";

import VocabularyPreviewController from "./vocabulary_preview_controller";
import SwiperController from "./swiper_controller";
import VisibilityController from "./visibility_controller";
import DarkModeController from "./dark_mode_controller";

application.register("vocabulary-preview", VocabularyPreviewController);
application.register("swiper", SwiperController);
application.register("visibility", VisibilityController);
application.register("nested-form", RailsNestedForm)
application.register("multiselect", Multiselect)
application.register("dark-mode", DarkModeController)
